import Model, { attr, belongsTo } from '@ember-data/model';
import { arrayAttr, copyable } from 'eflex/decorators';

@copyable
class DecisionDefConfig extends Model {
  @attr('boolean', { defaultValue: true }) enabled;

  @arrayAttr decisionTags;

  @belongsTo('task-config', { async: false, inverse: 'decisionDefConfigs' }) taskConfig;
  @belongsTo('decision-def', { async: false, inverse: 'decisionDefConfigs' }) decisionDef;

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['decisionDef', 'taskConfig']),
    };
  }
}

export default DecisionDefConfig;
